














import Vue from 'vue'
import Component from 'vue-class-component'

@Component<SearchFilterMobileButton>({
  props: {
    title: String,
    filtersChosenText: String,
    chosenFilters: Array,
  }
})

export default class SearchFilterMobileButton extends Vue {
  /**
   * Props variables
   */


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
   changeActiveFilter() {
    this.$emit('changeActiveFilter')
   }

  /**
   * Methods
   */

}
